import type { FakeCommentFileAction } from './cfakecommentTypes';

export const FAKE_COMMENT_MESSAGE_KIND = {
  Text: 'text',
  FileAction: 'fileAction',
} as const;

export const FAKE_COMMENT_FILE_ACTION = {
  Added: 'added',
  Edited: 'edited',
} as const;

export const FAKE_COMMENT_FILE_ACTION_LABELS: Record<FakeCommentFileAction, string> = {
  [FAKE_COMMENT_FILE_ACTION.Added]: 'Added a file',
  [FAKE_COMMENT_FILE_ACTION.Edited]: 'Edited a file',
};

export const FAKE_COMMENT_ADDED_VERSION_LABEL = 'V1';
export const FAKE_COMMENT_EDITED_VERSION_LABEL = 'V4';
export const FAKE_COMMENT_AUTO_MARGIN = 'auto';
